import React from 'react';

const Product: React.FC = () => {
    return (
        <article className="aboutus">
            <h1>產品簡介</h1>
            <ul>
                <li>1.客製化服務開發</li>
                <p>我們爲每位顧客量身打造專屬於你的實用性平台,爲你降低種種風險,提高每位顧客的收益。</p>
                <li>2.產品創新與研發</li>
                <p>我們隨時注意市場取向,了解最新產品,並致力於各項產品的新開發與設計,期許引領科技產業的最前端。</p>
                <li>3.整合服務</li>
                <p>我們整合產品,整合市場,讓選擇我們的各大企業能更簡易的了解我們的產品,加快上手的速度。</p>
            </ul>
        </article>
    );
};

export default Product;